/**
 * Thrown when a gateway returns HTTP 429 from rate-limit middleware.
 */
export class RateLimitError extends Error {
    url;
    constructor(message, url) {
        super(message);
        this.url = url;
        this.name = 'RateLimitError';
    }
}
/**
 * Type guard for {@link RateLimitError} from gateway SDK calls.
 */
export function isRateLimitError(error) {
    return error instanceof RateLimitError;
}
/**
 * Map rate-limit responses to a typed error; keep other HTTP failures generic.
 */
export async function throwForFailedHttpResponse(url, resp, text, options) {
    // Matches HTTP 429 from core/backend/libs/framework/src/rate-limit/rate-limiter.ts
    if (resp.status === 429) {
        let message = 'Too many requests, please try again later.';
        if (options.includeResponseBodyInMessage) {
            try {
                const bodyText = await text();
                const body = JSON.parse(bodyText);
                if (body.message)
                    message = body.message;
            }
            catch {
                // ignore malformed body
            }
        }
        throw new RateLimitError(message, url);
    }
    const details = options.includeResponseBodyInMessage
        ? ' - ' + (await text())
        : '';
    throw new Error(`${url} failed: ${resp.status} - ${resp.statusText}${details}`);
}
//# sourceMappingURL=http-client-errors.js.map